var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTribal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    "data-name": "Rectangle 1727",
    width: 20.524,
    height: 21.042,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_3:_Tribal_Alignment",
    "data-name": "Stage 3: Tribal Alignment",
    transform: "translate(-592 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592 301.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32055",
    "data-name": "Group 32055",
    transform: "translate(595.737 305.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32054",
    "data-name": "Group 32054",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M16.863,0a2.451,2.451,0,1,1-2.451,2.451A2.451,2.451,0,0,1,16.863,0h0m-6.6,1.165A2.451,2.451,0,1,1,7.812,3.616a2.451,2.451,0,0,1,2.451-2.451M3.663,0A2.451,2.451,0,1,1,1.212,2.451,2.451,2.451,0,0,1,3.663,0M5.875,15.044h-.43L5.115,19.6a.291.291,0,0,1-.29.27H2.5a.292.292,0,0,1-.291-.27l-.33-4.559A1.488,1.488,0,0,1,.434,13.6L0,7.176A1.418,1.418,0,0,1,1.392,5.731H5.875a1.451,1.451,0,0,1,1.208.651A2.188,2.188,0,0,0,5.858,8.344v6.42c0,.026.018.284.017.284m7.615-.284a1.491,1.491,0,0,1-1.448,1.45l-.33,4.558a.292.292,0,0,1-.291.27H9.1a.288.288,0,0,1-.29-.27L8.48,16.214a1.491,1.491,0,0,1-1.448-1.45L6.6,8.344A1.421,1.421,0,0,1,7.991,6.9h4.484a1.42,1.42,0,0,1,1.448,1.391v.057Zm6.6-1.165a1.488,1.488,0,0,1-1.448,1.448l-.33,4.559a.294.294,0,0,1-.291.27H15.7a.291.291,0,0,1-.29-.27l-.332-4.559h-.435a2.246,2.246,0,0,0,.02-.284V8.343A2.194,2.194,0,0,0,13.441,6.38a1.451,1.451,0,0,1,1.207-.65h4.427a1.419,1.419,0,0,1,1.448,1.389v.059Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribal);
export default __webpack_public_path__ + "static/media/tribal.f800a1d07221baecf5f8a56d8f4d4b48.svg";
export { ForwardRef as ReactComponent };